// extracted by mini-css-extract-plugin
export default {"title":"UpdateCompanyModal_title__wKVfj","Modal":"UpdateCompanyModal_Modal__n5o72","Overlay":"UpdateCompanyModal_Overlay__reOwT"};